import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Отчет об ошибке", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle2" }, " Поддержка изучит проблему ", -1)
const _hoisted_3 = { class: "text-caption text-center text-white" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Снимок экрана может иметь погрешности ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" в положении прокрутки страницы и стилистике ")


import { PropType, reactive } from 'vue';
import * as Pico from '@gripeless/pico';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import { useMainStore } from '@/store';

const __default__ = { name: 'BugReport' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $q = useQuasar();
$q.loadingBar.setDefaults({
  color: 'teal',
  size: '5px',
  position: 'top',
});

const data = reactive({
  seamless: false,
  src: '' as any,
  text: '',
});

const cancelReport = () => {
  data.text = '';
  data.src = '';
  data.seamless = false;
};

const makeSnapshot = async () => {
  useMainStore().reportMode = true;
  let screenshot = (await Pico.objectURL(window)).value;
  screenshot = (await Pico.objectURL(window)).value;
  data.src = screenshot;
  useMainStore().reportMode = false;
  data.seamless = true;
};

const sendBugReport = async () => {
  $q.loadingBar.start();
  await useMainStore().sendBugReport({
    file: data.src,
    text: data.text,
  });
  cancelReport();
  $q.loadingBar.stop();
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      round: "",
      push: "",
      color: "green-14",
      icon: "bug_report",
      size: "10px",
      disable: data.seamless,
      onClick: _withModifiers(makeSnapshot, ["stop"])
    }, null, 8, ["disable", "onClick"]),
    _createVNode(_component_q_dialog, {
      modelValue: data.seamless,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.seamless) = $event)),
      seamless: "",
      position: "bottom",
      class: "report-dialog"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, {
          style: {"width":"350px"},
          class: "bg-red-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-center text-white q-my-sm" }, {
              default: _withCtx(() => [
                _hoisted_1,
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, {
              class: "report-dialog__section flex",
              id: "snapshot"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_img, {
                  src: data.src,
                  width: "60%",
                  height: "60%",
                  style: {"border-radius":"0.25rem","box-shadow":"12px 12px 2px 1px rgba(0, 0, 255, .2)"},
                  class: "bg-white q-mx-auto"
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-mt-md" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_q_icon, {
                      size: "16px",
                      name: "error",
                      color: "primary",
                      class: "q-ml-md q-my-auto"
                    }),
                    _hoisted_4,
                    _createVNode(_component_q_icon, {
                      size: "16px",
                      name: "error",
                      color: "primary",
                      class: "q-mr-md q-my-auto"
                    }),
                    _hoisted_5,
                    _hoisted_6
                  ])
                ]),
                _createVNode(_component_q_input, {
                  color: "white",
                  class: "light-form q-mx-md q-mb-sm",
                  modelValue: data.text,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.text) = $event)),
                  filled: "",
                  clearable: "",
                  autogrow: "",
                  autofocus: "",
                  label: "Место, чтобы пожаловаться",
                  hint: "Подробно опишите проблему, с которой столкнулись",
                  type: "text"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_btn_group, { spread: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_btn, {
                      "text-color": "white",
                      icon: "send",
                      label: "Отправить",
                      onClick: sendBugReport
                    }),
                    _createVNode(_component_q_btn, {
                      "text-color": "white",
                      icon: "cancel",
                      label: "Отменить",
                      onClick: cancelReport
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})